// extracted by mini-css-extract-plugin
export var acitonButtons = "_hx-0";
export var additionalIcon = "_hx-f";
export var block = "_hx-1";
export var blockContent = "_hx-7";
export var blockDescription = "_hx-8";
export var blockIcon = "_hx-9";
export var blockTitle = "_hx-6";
export var border = "_hx-a";
export var center = "_hx-l";
export var edge = "_hx-b";
export var edgeLabel = "_hx-c";
export var edgePath = "_hx-d";
export var error = "_hx-e";
export var flowchart = "_hx-g";
export var flowchartContent = "_hx-h";
export var highlighted = "_hx-3";
export var hover = "_hx-4";
export var icon = "_hx-i";
export var left = "_hx-m";
export var navButton = "_hx-j";
export var navButtons = "_hx-k";
export var right = "_hx-n";
export var selected = "_hx-2";
export var small = "_hx-5";